import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "description"];
import EmbeddedCommentableArea from './EmbeddedCommentableArea';
import ChildrenErrorBoundary from '../../../components/errors/ChildrenErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ControlledCommentableArea(_ref) {
  let {
      children,
      description
    } = _ref,
    propsForWrapper = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ChildrenErrorBoundary, {
    originalChildren: children,
    children: /*#__PURE__*/_jsx(EmbeddedCommentableArea, Object.assign({
      metaDescription: description
    }, propsForWrapper, {
      children: children
    }))
  });
}